"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redactSignInLinkTokens = exports.applyCtaButtonTheme = exports.applyWysiwygButtonLabelColor = exports.stripTransactionReceiptBlock = exports.stripInlineTextColorsFromEmailBody = exports.inlineOrgFooterLogoForPreview = exports.inlineOrgEmailCidImagesForPreview = exports.ORG_EMAIL_CID_IMAGES = exports.ORG_FLASH_ICON_IMAGE = exports.ORG_SCAN_ICON_IMAGE = exports.ORG_CREDIT_CARD_ICON_IMAGE = exports.ORG_CHECK_IN_MANAGER_IMAGE = exports.ORG_FOOTER_ZEFFY_LOGO = exports.buildV2EmailBranding = void 0;
const icons_1 = require("../email-templates/icons");
const email_theme_tokens_1 = require("./email-theme-tokens");
const ZEFFY_LOGO_BY_VARIANT = {
    light: { contentId: "icon-zeffy-light", base64: icons_1.EMAIL_ICON_BASE64.zeffyLight, cid: icons_1.EMAIL_ICON_CID.zeffyLight },
    dark: { contentId: "icon-zeffy-dark", base64: icons_1.EMAIL_ICON_BASE64.zeffyDark, cid: icons_1.EMAIL_ICON_CID.zeffyDark },
};
/**
 * Resolves the v2 theme tokens + the donor-facing Zeffy logo CID inline attachment. The logo ships as an
 * inline (CID) attachment so it renders reliably across clients; the variant (light/dark 2-tone wordmark)
 * is derived from the org brand color. Org-facing emails do NOT use this logo — their footer hardcodes the
 * green-swoosh logo CID itself (see ORG_FOOTER_ZEFFY_LOGO), so no caller wires that one.
 */
const buildV2EmailBranding = (color, isDarkMode) => {
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    const logo = ZEFFY_LOGO_BY_VARIANT[theme.zeffyLogoVariant];
    const inlineIconAttachments = [
        {
            content: logo.base64,
            filename: `${logo.contentId}.png`,
            type: "image/png",
            disposition: "inline",
            content_id: logo.contentId,
        },
    ];
    return { theme, zeffyLogoCid: logo.cid, inlineIconAttachments };
};
exports.buildV2EmailBranding = buildV2EmailBranding;
/**
 * The organization-facing footer (org-footer.hbs) hardcodes this Zeffy logo CID, so the logo is owned by
 * the footer partial itself — no caller or theme has to pass it. `cid` is what the partial emits; `attachment`
 * is the matching inline PNG the transactional service ships whenever `cid` appears in the rendered HTML.
 */
exports.ORG_FOOTER_ZEFFY_LOGO = {
    cid: icons_1.EMAIL_ICON_CID.zeffyDarkGreenWind,
    attachment: {
        content: icons_1.EMAIL_ICON_BASE64.zeffyDarkGreenWind,
        filename: "icon-zeffy-dark-green-wind.png",
        type: "image/png",
        disposition: "inline",
        content_id: "icon-zeffy-dark-green-wind",
    },
};
exports.ORG_CHECK_IN_MANAGER_IMAGE = {
    cid: icons_1.EMAIL_ICON_CID.checkInManager,
    attachment: {
        content: icons_1.EMAIL_ICON_BASE64.checkInManager,
        filename: "img-check-in-manager.png",
        type: "image/png",
        disposition: "inline",
        content_id: "img-check-in-manager",
    },
};
const buildStoreBadgeImage = (name) => {
    const contentId = icons_1.EMAIL_ICON_CID[name].replace("cid:", "");
    return {
        cid: icons_1.EMAIL_ICON_CID[name],
        dataUri: icons_1.EMAIL_ICON_DATA_URI[name],
        attachment: {
            content: icons_1.EMAIL_ICON_BASE64[name],
            filename: `${contentId}.png`,
            type: "image/png",
            disposition: "inline",
            content_id: contentId,
        },
    };
};
const STORE_BADGE_IMAGES = [
    "googlePlayBadge",
    "googlePlayBadgeFr",
    "googlePlayBadgeDe",
    "appStoreBadge",
    "appStoreBadgeFr",
    "appStoreBadgeDe",
].map(buildStoreBadgeImage);
const buildBenefitIconImage = (name, contentId) => ({
    cid: icons_1.EMAIL_ICON_CID[name],
    attachment: {
        content: icons_1.EMAIL_ICON_BASE64[name],
        filename: `${contentId}.png`,
        type: "image/png",
        disposition: "inline",
        content_id: contentId,
    },
});
exports.ORG_CREDIT_CARD_ICON_IMAGE = buildBenefitIconImage("creditCard", "icon-credit-card");
exports.ORG_SCAN_ICON_IMAGE = buildBenefitIconImage("scan", "icon-scan");
exports.ORG_FLASH_ICON_IMAGE = buildBenefitIconImage("flash", "icon-flash");
exports.ORG_EMAIL_CID_IMAGES = [
    {
        cid: icons_1.EMAIL_ICON_CID.dafFacebook,
        dataUri: icons_1.EMAIL_ICON_DATA_URI.dafFacebook,
        attachment: {
            content: icons_1.EMAIL_ICON_BASE64.dafFacebook,
            filename: "icon-daf-facebook.png",
            type: "image/png",
            disposition: "inline",
            content_id: "icon-daf-facebook",
        },
    },
    {
        cid: icons_1.EMAIL_ICON_CID.dafLinkedin,
        dataUri: icons_1.EMAIL_ICON_DATA_URI.dafLinkedin,
        attachment: {
            content: icons_1.EMAIL_ICON_BASE64.dafLinkedin,
            filename: "icon-daf-linkedin.png",
            type: "image/png",
            disposition: "inline",
            content_id: "icon-daf-linkedin",
        },
    },
    {
        cid: icons_1.EMAIL_ICON_CID.dafInstagram,
        dataUri: icons_1.EMAIL_ICON_DATA_URI.dafInstagram,
        attachment: {
            content: icons_1.EMAIL_ICON_BASE64.dafInstagram,
            filename: "icon-daf-instagram.png",
            type: "image/png",
            disposition: "inline",
            content_id: "icon-daf-instagram",
        },
    },
    {
        cid: icons_1.EMAIL_ICON_CID.dafQuote,
        dataUri: icons_1.EMAIL_ICON_DATA_URI.dafQuote,
        attachment: {
            content: icons_1.EMAIL_ICON_BASE64.dafQuote,
            filename: "icon-daf-quote.png",
            type: "image/png",
            disposition: "inline",
            content_id: "icon-daf-quote",
        },
    },
    { ...exports.ORG_FOOTER_ZEFFY_LOGO, dataUri: icons_1.EMAIL_ICON_DATA_URI.zeffyDarkGreenWind },
    { ...exports.ORG_CHECK_IN_MANAGER_IMAGE, dataUri: icons_1.EMAIL_ICON_DATA_URI.checkInManager },
    ...STORE_BADGE_IMAGES,
    { ...exports.ORG_CREDIT_CARD_ICON_IMAGE, dataUri: icons_1.EMAIL_ICON_DATA_URI.creditCard },
    { ...exports.ORG_SCAN_ICON_IMAGE, dataUri: icons_1.EMAIL_ICON_DATA_URI.scan },
    { ...exports.ORG_FLASH_ICON_IMAGE, dataUri: icons_1.EMAIL_ICON_DATA_URI.flash },
];
const inlineOrgEmailCidImagesForPreview = (html) => exports.ORG_EMAIL_CID_IMAGES.reduce((out, image) => out.split(image.cid).join(image.dataUri), html);
exports.inlineOrgEmailCidImagesForPreview = inlineOrgEmailCidImagesForPreview;
/**
 * Browser preview only: swaps the org-footer's hardcoded logo CID for its data URI so the logo shows in
 * Storybook / local HTML previews (browsers can't resolve `cid:`). Email clients keep the CID and receive
 * the inline PNG attachment instead. No-op on HTML that doesn't reference the logo.
 */
const inlineOrgFooterLogoForPreview = (html) => html.split(exports.ORG_FOOTER_ZEFFY_LOGO.cid).join(icons_1.EMAIL_ICON_DATA_URI.zeffyDarkGreenWind);
exports.inlineOrgFooterLogoForPreview = inlineOrgFooterLogoForPreview;
const stripInlineTextColorsFromEmailBody = (html) => {
    return html.replace(/(?<![\w-])color\s*:[^;"]+;?/gi, "").replace(/-webkit-text-fill-color\s*:[^;"]+;?/gi, "");
};
exports.stripInlineTextColorsFromEmailBody = stripInlineTextColorsFromEmailBody;
const LEGACY_TRANSACTION_RECEIPT_MARKER_REGEX = /<!--\s*Transaction Receipt\s*-->/i;
const LEGACY_TRANSACTION_RECEIPT_HINT_REGEX = /<!--\s*Transaction Receipt\b/i;
const CURRENT_TRANSACTION_RECEIPT_ROW_REGEX = /<tr\b[^>]*\bdata-section\s*=\s*(?:"receipt"|'receipt')[^>]*>/i;
const CURRENT_TRANSACTION_RECEIPT_HINT_REGEX = /\bdata-section\s*=\s*(?:"receipt"|'receipt'|receipt\b)/i;
const TABLE_ROW_TAG_REGEX = /<\/?tr\b[^>]*>/gi;
const stripTransactionReceiptBlock = (html) => {
    const legacyMarker = LEGACY_TRANSACTION_RECEIPT_MARKER_REGEX.exec(html);
    const currentReceiptRow = CURRENT_TRANSACTION_RECEIPT_ROW_REGEX.exec(html);
    if (!legacyMarker && !currentReceiptRow) {
        return LEGACY_TRANSACTION_RECEIPT_HINT_REGEX.test(html) || CURRENT_TRANSACTION_RECEIPT_HINT_REGEX.test(html)
            ? null
            : html;
    }
    const useLegacyMarker = legacyMarker !== null && (currentReceiptRow === null || legacyMarker.index < currentReceiptRow.index);
    const removalStart = useLegacyMarker ? legacyMarker.index : currentReceiptRow.index;
    let receiptRowStart = currentReceiptRow?.index ?? -1;
    if (useLegacyMarker) {
        const rowAfterMarkerRegex = new RegExp(TABLE_ROW_TAG_REGEX.source, TABLE_ROW_TAG_REGEX.flags);
        rowAfterMarkerRegex.lastIndex = legacyMarker.index + legacyMarker[0].length;
        const rowAfterMarker = rowAfterMarkerRegex.exec(html);
        const contentBetweenMarkerAndRow = rowAfterMarker
            ? html.slice(legacyMarker.index + legacyMarker[0].length, rowAfterMarker.index)
            : "";
        if (!rowAfterMarker || rowAfterMarker[0].startsWith("</") || contentBetweenMarkerAndRow.trim()) {
            return null;
        }
        receiptRowStart = rowAfterMarker.index;
    }
    const rowTagRegex = new RegExp(TABLE_ROW_TAG_REGEX.source, TABLE_ROW_TAG_REGEX.flags);
    rowTagRegex.lastIndex = receiptRowStart;
    let depth = 0;
    for (let rowTag = rowTagRegex.exec(html); rowTag; rowTag = rowTagRegex.exec(html)) {
        if (rowTag.index === receiptRowStart && rowTag[0].startsWith("</")) {
            return null;
        }
        depth += rowTag[0].startsWith("</") ? -1 : 1;
        if (depth < 0) {
            return null;
        }
        if (depth === 0) {
            const projectedHtml = html.slice(0, removalStart) + html.slice(rowTagRegex.lastIndex);
            return LEGACY_TRANSACTION_RECEIPT_HINT_REGEX.test(projectedHtml) ||
                CURRENT_TRANSACTION_RECEIPT_HINT_REGEX.test(projectedHtml)
                ? null
                : projectedHtml;
        }
    }
    return null;
};
exports.stripTransactionReceiptBlock = stripTransactionReceiptBlock;
const EMAIL_SAFE_BUTTON_LABEL_STYLE = "color:#ffffff !important;-webkit-text-fill-color:#ffffff !important;font-family:Arial, Helvetica, sans-serif !important";
const applyWysiwygButtonLabelColor = (html) => {
    return html.replace(/<span\b[^>]*\bdata-button-color\s*=[^>]*>/gi, (tag) => {
        const styleMatch = tag.match(/(?<![-\w])style\s*=\s*(["'])([\s\S]*?)\1/i);
        if (!styleMatch) {
            return tag.replace(/<span\b/i, `<span style="${EMAIL_SAFE_BUTTON_LABEL_STYLE}"`);
        }
        const [rawStyleAttr, quote, styleValue] = styleMatch;
        const cleaned = styleValue.trim().replace(/;\s*$/, "");
        const merged = cleaned.length > 0 ? `${cleaned};${EMAIL_SAFE_BUTTON_LABEL_STYLE}` : EMAIL_SAFE_BUTTON_LABEL_STYLE;
        return tag.replace(rawStyleAttr, () => `style=${quote}${merged}${quote}`);
    });
};
exports.applyWysiwygButtonLabelColor = applyWysiwygButtonLabelColor;
const applyCtaButtonTheme = (html, { ctaBg, ctaText }) => {
    return html.replace(/<a\b[^>]*>/gi, (tag) => {
        const styleMatch = tag.match(/(?<![-\w])style\s*=\s*(["'])([\s\S]*?)\1/i);
        if (!styleMatch || !/background-color\s*:/i.test(styleMatch[2])) {
            return tag;
        }
        const [rawStyleAttr, quote, styleValue] = styleMatch;
        const preservedDeclarations = styleValue
            .split(";")
            .map((declaration) => declaration.trim())
            .filter((declaration) => declaration.length > 0 &&
            !/^(background-color|color|-webkit-text-fill-color|text-decoration)\s*:/i.test(declaration));
        const themedStyle = [
            ...preservedDeclarations,
            `background-color:${ctaBg} !important`,
            `color:${ctaText} !important`,
            `-webkit-text-fill-color:${ctaText} !important`,
            `text-decoration:none !important`,
        ].join(";");
        return tag.replace(rawStyleAttr, () => `style=${quote}${themedStyle};${quote}`);
    });
};
exports.applyCtaButtonTheme = applyCtaButtonTheme;
const MANAGE_LINK_TOKEN_REGEX = /(manage-recurring-donation)(?:\?|#|%23)token(?:=|&#x3D;|&#61;|%3D)[\w.~%-]+/gi;
const redactSignInLinkTokens = (html) => html.replace(MANAGE_LINK_TOKEN_REGEX, "$1");
exports.redactSignInLinkTokens = redactSignInLinkTokens;
